// src/i18n/es/preferences.ts
// «Mis preferencias» (mockup 13, first tab) + the preferences store.
export const preferences = {
  title: 'Mis preferencias',
  subtitle: 'Cómo quiere ver usted las cosas. Se guarda por usuario.',
  tabs: {
    mine: 'Mis preferencias',
    hotel: 'Opciones del hotel',
    roommatik: 'Opciones de Roommatik',
  },
  fields: {
    language: 'Idioma',
    landingPage: 'Página de inicio',
    defaultScope: 'Alcance por defecto',
    tableDensity: 'Densidad de las tablas',
  },
  landingPageOptions: {
    arrivals: 'Llegadas de hoy',
    reservations: 'Reservas',
    summary: 'Resumen',
  },
  defaultScopeOptions: {
    remembered: 'Recordar la última selección',
    allHotels: 'Todos los hoteles',
  },
  tableDensityOptions: {
    comfortable: 'Cómoda',
    compact: 'Compacta',
  },
  saved: 'Preferencias guardadas correctamente.',
  saveError: 'No se pudieron guardar las preferencias. Se han guardado en este dispositivo.',
  loadError: 'No se pudieron cargar sus preferencias del servidor. Se muestran las guardadas en este dispositivo.',
};

export default preferences;
